import axios from 'axios'
import utils from './utils'

function CancelableRequest(promise, source) {
    this.promise = promise;
    this.source = source;
}

CancelableRequest.prototype.cancel = function () {
    if (this.source) {
        this.source.cancel();
    }
};

export default {
    request(url, method, data, cancelable, headers) {
        let source = null;
        if (cancelable === true) {
            source = axios.CancelToken.source();
        }

        let promise = new Promise((resolve, reject) => {
            let request = {
                method: method,
                url: url,
                responseType: 'json'
            };
            if (headers) {
                headers['X-Requested-With'] = 'XMLHttpRequest';
                if (!headers['Content-Type']) {
                    headers['Content-Type'] = 'application/json';
                }
                request.headers = headers;
            } else {
                request.headers = {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                };
            }

            if (cancelable === true) {
                request.cancelToken = source.token;
            }

            if (method === 'get' || method === 'delete') {
                request.params = data;
            } else {
                if (utils.isPlainObject(data)) {
                    let formData = new FormData();
                    for (let key in data) {
                        if (Object.hasOwnProperty.call(data, key)) {
                            formData.append(key, data[key]);
                        }
                    }
                    request.data = formData;
                } else {
                    request.data = data;
                }
            }
            axios(request)
                .then((response) => {
                    let r = response.data;
                    if (r && Object.hasOwnProperty.call(r, 'status')) {
                        if (r.status === 'success' || r.status === true) {
                            resolve(r);
                        } else {
                            reject(r);
                        }
                    } else {
                        resolve(r);
                    }
                })
                .catch((e) => {
                    let params = {};

                    if (e?.response) {
                        params = {
                            response: e.response,
                            status: e.response.status,
                            isCancel: axios.isCancel(e)
                        };

                        if (e?.response?.data?.data?.message) {
                            params['error'] = e.response.data.data.message;
                        } else if (e?.response?.data?.message) {
                            params['error'] = e.response.data.message;
                        } else {
                            params['error'] = 'Ошибка выполнения запроса';
                        }
                    }

                    reject(params);
                });
        })

        if (cancelable === true) {
            return new CancelableRequest(promise, source)
        }

        return promise
    }
}